import { useState, useEffect, useContext, useReducer } from "react";
import { useNavigate } from 'react-router-dom';
import { useTable, usePagination } from 'react-table';
import Select from 'react-select';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import PartnerReadOnlyRow from "../../components/PartnerReadOnlyRow";
import PartnerModal from "../../components/PartnerModal";
import PartnerDetailsModal from "../../components/PartnerDetailsModal";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { ddStyles } from "../../utils/CommonStyles.js";

const initialState = {
    queryPageIndex: 0,
    queryPageSize: 25,
    totalCount: 0,
    queryPageFilter: 0,
};

const PAGE_CHANGED = 'PAGE_CHANGED';
const TOTAL_COUNT_CHANGED = 'TOTAL_COUNT_CHANGED';
const PAGE_FILTER_CHANGED = 'PAGE_FILTER_CHANGED';

const reducer = (state, { type, payload, t }) => {
    switch (type) {
        case PAGE_CHANGED:
            return {
                ...state,
                queryPageIndex: payload.pageIndex,
            };
        case TOTAL_COUNT_CHANGED:
            return {
                ...state,
                totalCount: payload.count,
            };
        case PAGE_FILTER_CHANGED:
            return {
                ...state,
                queryPageFilter: payload.supplierCompanyId || 0,
				totalCount: 0,
                queryPageIndex: 0,
            };
        default:
            throw new Error(t("error.unhandledException") + " : ${type}");
    }
};

let prevCount = 0;
function setPrevCount(newCount) {
    prevCount = newCount;
}


function ListPartners() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [add, setAdd] = useState(false);
    const [isNew, setIsNew] = useState(false);

    const [errorValue, setErrorValue] = useState("");
    const [data, setData] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [keyCount, setKeyCount] = useState(0);
    const [count, setCount] = useState(0);
    const [supplierCompanyId, setSupplierCompanyId] = useState(0);
    const [supplierCompanyName, setSupplierCompanyName] = useState("");
    const [companyLoaded, setCompanyLoaded] = useState(false);
    const [companySelected, setCompanySelected] = useState({ name: "companyId", label: "", value: 0 });
    const [useFilter, setUseFilter] = useState(false);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);
    const today = new Date().toISOString().split("T")[0];
    const [columns, setColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [details, setDetails] = useState(false);

    useEffect(() => {
        fetchCompanies();
        setColumns([
            { accessor: 'companyName', Header: t("page.name"), maxWidth: "18vw" },
            { accessor: 'partnerNumber', Header: t("page.companyNumber"), maxWidth: "10vw" },
            { accessor: 'companyType', Header: t("page.company.type"), maxWidth: "7vw" },
            { accessor: 'address', Header: t("page.address"), maxWidth: "20vw" },
            { accessor: 'addSurvey', Header: t("page.survey.canadd"), maxWidth: "5vw" },
            { accessor: 'canShareBrokerWithBuyer', Header: t("page.broker.share"), maxWidth: "5vw" },
            { accessor: 'status', Header: t("page.status"), maxWidth: "5vw" },
            { accessor: 'action', Header: t("page.action"), maxWidth: "16vw" },
        ]);
    }, []);

    const initialValues = {
        partnershipKey: 0,
        supplierCompanyId: 0,
        clientCompanyId: 0,
        clientCompanyName: "",
        rawProduct: true,
        finishedProduct: true,
        addUpdateSurvey: false,
        canShareBrokerWithBuyer: false,
        partnerNumber: "",
        statusCode: 1
    };

    const [editFormData, setEditFormData] = useState(initialValues);

    function fetchCompanies() {
        setErrorValue("");
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("FetchCompanies", "/Service/CompanyService/FetchCompanies", requestOptions, fetchCompaniesSuccess, fetchCompaniesFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function fetchCompaniesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.companyListNotRetrieved"));
    }
    function fetchCompaniesSuccess(responseData) {
        let fetchCompaniesResponse;
        if (responseData) {
            fetchCompaniesResponse = responseData.fetchCompaniesResponse;
            if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "0") {
                setCompanyValues(fetchCompaniesResponse.companies);
                setCompanies(fetchCompaniesResponse.companies);
            } else if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchCompaniesResponse) {
                setErrorValue(t("error.error") + " " + fetchCompaniesResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
    }
    function setCompanyValues(companyObj) {
        let companyValue = {};
        let companyOptionList = [];
        companyOptionList.push({ label: "", value: 0 });
        if (companyObj && companyObj.length > 0) {
            companyObj.map((company, index) => {
                companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
                companyValue.value = company.companyId;
                companyOptionList.push(companyValue);
                companyValue = {};
            });
        }
        setCompanyOptions(companyOptionList);
        setCompanyLoaded(true);
    }

    const companyHandler = (selectedOption, action) => {
        let companyId = selectedOption ? selectedOption.value : 0;
        let companyName = selectedOption ? selectedOption.label : "";

        if (companyId === supplierCompanyId) {
            return
        }

        setSupplierCompanyId(companyId);
        setSupplierCompanyName(companyName);
        setCompanySelected({ ...companySelected, label: companyName, value: companyId });
        initialValues.supplierCompanyId = companySelected.value;
        initialValues.partnershipKey = 0;
        initialValues.clientCompanyId = 0;
        initialValues.clientCompanyName = "";
        setEditFormData(initialValues);
                
        if (companyId && companyId > 0) {
            setUseFilter(true);
            setAdd(true);
        } else {
			setUseFilter(false);
			setCount(0);
            setData([]);
            setAdd(false);
        }
    }

    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter }, dispatch] =
        useReducer(reducer, initialState);

    const { isError, error, isSuccess, refetch } = useQuery(
        ['partner-list', queryPageIndex, queryPageSize, queryPageFilter],
        () => retrievePartner(queryPageIndex, queryPageSize, queryPageFilter),
        {
            keepPreviousData: false,
            staleTime: 1000,
            enabled: useFilter,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        }
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        // Get the state from the instance
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data: isSuccess ? data : [],
            initialState: {
                pageIndex: queryPageIndex,
                pageSize: queryPageSize,
            },
            manualPagination: true,
            pageCount: isSuccess ? Math.ceil(count / queryPageSize) : null,
        },
        usePagination
    );

    useEffect(() => {
        dispatch({ type: PAGE_CHANGED, payload: { pageIndex: pageIndex, supplierCompanyId: supplierCompanyId }, t: t });
    }, [pageIndex]);

    useEffect(() => {
        if (count !== prevCount) {
            dispatch({
                type: TOTAL_COUNT_CHANGED,
                payload: { count: count, supplierCompanyId: supplierCompanyId },
                t: t
            });

            setPrevCount(count);
        }
    }, [count]);

    useEffect(() => {
            dispatch({ type: PAGE_FILTER_CHANGED, payload: { count: 0, supplierCompanyId: supplierCompanyId }, t: t });
            gotoPage(0);
    }, [useFilter, supplierCompanyId, gotoPage]);

    function retrievePartner(page, dispSize, parentCompanyInfo) {
        setErrorValue("");
        if (!parentCompanyInfo || parentCompanyInfo === 0) {
            return;
        }

        setIsLoading(true);
        const offset = page * dispSize;
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true,
                offset: offset, limit: dispSize, supplierCompanyId: parentCompanyInfo,
                includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartners", "/Service/CompanyService/GetPartners", requestOptions, retrievePartnerSuccess, retrievePartnerFail);
        } catch (error) {
            setIsLoading(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.partnerNotRetrieved"));
    }

    function retrievePartnerSuccess(responseData) {
        let getPartnersResponse;
        if (responseData) {
            getPartnersResponse = responseData.getPartnersResponse;
            if (getPartnersResponse && getPartnersResponse.errorCode === "0") {
                setData(getPartnersResponse.partnerList.slice());
                if (getPartnersResponse.offset === 0) {
                    setCount(getPartnersResponse.totalCount);
                }
            } else if (getPartnersResponse && getPartnersResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnersResponse) {
                setErrorValue(t("error.error") + " " + getPartnersResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }


    const handleAddClick = (event) => {
        event.preventDefault();
        setErrorValue("");
        setIsNew(true);
        setDetails(false);
        initialValues.partnershipKey = 0;
        initialValues.clientCompanyId = 0;
        initialValues.clientCompanyName = "";
        initialValues.rawProduct = true;
        initialValues.finishedProduct = true;
        initialValues.addUpdateSurvey = false;
        initialValues.canShareBrokerWithBuyer = false;
        initialValues.partnerNumber = "";
        setEditFormData(initialValues);
        setShow(true);

    }
    const handleEditClick = (event, partner) => {
        event.preventDefault();
        setErrorValue("");
        setIsNew(false);
        setAdd(false);
        setDetails(false);
        initialValues.partnershipKey = partner.partnershipKey;
        initialValues.clientCompanyId = partner.companyId;
        initialValues.clientCompanyName = partner.companyName;
        initialValues.rawProduct = partner.rawProduct;
        initialValues.finishedProduct = partner.finishedProduct;
        initialValues.addUpdateSurvey = partner.addUpdateSurvey;
        initialValues.canShareBrokerWithBuyer = partner.canShareBrokerWithBuyer;
        initialValues.partnerNumber = partner.partnerNumber;
        setEditFormData(initialValues);
        setShow(true);

    }
    const handleDeleteClick = (event, partnershipKey, clientCompanyId, statusCode) => {
        event.preventDefault();
        setErrorValue("");
        setIsNew(false);
        setAdd(false);
        setDetails(false);
        deletePartner(companySelected.value, partnershipKey, clientCompanyId, statusCode);
    };

    const handleDetailsClick = (event, partner) => {
        event.preventDefault();
        event.stopPropagation();
        setErrorValue("");
        initialValues.partnershipKey = partner.partnershipKey;
        initialValues.clientCompanyId = partner.companyId;
        initialValues.clientCompanyName = partner.companyName;
        initialValues.supplierCompanyId = supplierCompanyId;
        setEditFormData(initialValues);
        setShow(false);
        setAdd(false);
        setIsNew(false);
        setDetails(true);
    };
    const deletePartner = (supplierCompanyId, partnershipKey, clientCompanyId, statusCode) => {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", partnershipKey: partnershipKey, supplierCompanyId: supplierCompanyId, clientCompanyId: clientCompanyId,
                statusCode: statusCode, updatedById: userCtx.loggedInUserId
            }),
        };
        try {
            FetchUtil.fetchAPI("DeletePartner", "/Service/CompanyService/DeletePartner", requestOptions, deletePartnerSuccess, deletePartnerFail);
        } catch (error) {
            setErrorValue(error.message);
        }
    }

    function deletePartnerFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.partnerDeleteFailed"));
    }
    function deletePartnerSuccess(responseData) {
        let deletePartnerResponse;
        if (responseData) {
            deletePartnerResponse = responseData.deletePartnerResponse;
            if (deletePartnerResponse && deletePartnerResponse.errorCode === "0") {
                // only retrieve the modified user
                handleRefresh();
            } else if (deletePartnerResponse) {
                handleRefresh();
                setErrorValue(t("error.error") + " " + deletePartnerResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.update"));
            }
        }
    }

    const handleRefresh = () => {
        refetch();
        setAdd(true);
        setKeyCount(prevCount => prevCount + 1);
    };

    const actionComplete = () => {
        setAdd(true);
    };

    if (isError) {
        setErrorValue(t("error.error") + " " + error.message);
    }

    return (
        <div className="container-fluid">
            <Header />
            <div className={(show || details) ? "container-fluid container_list viewh-85 pe-none" : "container-fluid container_list viewh-85"}>
                {(userCtx.role === "SiteAdmin") ?
                    <>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="inerrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <div id="placeholder_1" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="form-label">
                                        <span className="form_required">*</span>
                                        {t("page.supplier")}
                                    </label>
                                    <Select
                                        name="companyId"
                                        options={companyOptions}
                                        onChange={companyHandler}
                                        placeholder={""}
                                        value={companySelected}
                                        isSearchable={companyLoaded}
                                        isClearable={companyLoaded}
                                        className="myselect"
                                        inputId="companyId-input"
                                        styles={ddStyles}
                                    />
                                </div>
                            </div>
                            {(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div id="placeholder_2" className="placeholder-pg"></div>
                            </div>
                        </div>
                        {add &&
                            <div className="row">
                                <div className="col">
                                    <button className="btn btn-primary btn-block me-4" data-toggle="modal" data-target="#partnerModal"
                                        onClick={(event) => handleAddClick(event)}>{t("page.buyer.add")}</button>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col">
                                {isSuccess ? (
                                    <>
                                        <table key={keyCount} className="list-table" {...getTableProps()}>
                                            <thead>
                                                {headerGroups.map(headerGroup => (
                                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                                        {headerGroup.headers.map(column => (
                                                            <th className="list-th" {...column.getHeaderProps({
                                                                style: { maxWidth: column.maxWidth },
                                                            })}>{column.render("Header")}</th>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>
                                            <tbody {...getTableBodyProps()}>
                                                {data.length > 0 && (
                                                    data.map((partner, index) => (
                                                        (partner) &&
                                                        <PartnerReadOnlyRow
                                                            t={t}
                                                            supplierCompanyId={supplierCompanyId}
                                                            partner={partner}
                                                            handleDeleteClick={handleDeleteClick}
                                                            handleEditClick={handleEditClick}
                                                            handleDetailsClick={handleDetailsClick}
                                                            oddIdx={((index % 2) > 0) ? true : false}
                                                        />
                                                    ))
                                                )}
                                            </tbody>

                                        </table>

                                        <div className="pagination">
                                            <button className="nav-button" onClick={() => { gotoPage(0); }} disabled={!canPreviousPage}>
                                                {'<<'}
                                            </button>
                                            <button className="nav-button" onClick={() => { previousPage(); }} disabled={!canPreviousPage}>
                                                {'<'}
                                            </button>
                                            <button className="nav-button" onClick={() => { nextPage(); }} disabled={!canNextPage}>
                                                {'>'}
                                            </button>
                                            <button className="nav-button"
                                                onClick={() => { gotoPage(pageCount - 1); }}
                                                disabled={!canNextPage}
                                            >
                                                {'>>'}
                                            </button>
                                            <span className="nav-page-info">{t("page.page") + ' '}
                                                <strong>
                                                    {pageOptions.length > 0 ? pageIndex + 1 : 0} {t("page.of")} {pageOptions.length}
                                                </strong>
                                            </span>
                                            <span className="nav-page-goto">{t("page.goToPage")}:{' '}
                                                <input
                                                    type="number"
                                                    value={pageIndex + 1}
                                                    onChange={(e) => {
                                                        const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                                        gotoPage(page);
                                                    }}
                                                    className="nav-goto-input"
                                                />
                                            </span>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </div>
                        {add &&
                            <div className="row">
                                <div className="col">
                                    <button className="btn btn-primary btn-block me-4" data-toggle="modal" data-target="#partnerModal"
                                        onClick={(event) => handleAddClick(event)}>{t("page.buyer.add")}</button>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col">
                                <div
                                    id="berrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>
                    </>
                    : null}
            </div>
            <div className="footer_container">
                <Footer />
            </div>
            {show && <PartnerModal key={keyCount} t={t} companyList={companies} supplierCompanyId={supplierCompanyId} setShow={setShow} isNew={isNew} formdata={editFormData} refetch={handleRefresh} editComplete={actionComplete} />}
            {details && <PartnerDetailsModal key={keyCount} t={t} partner={editFormData} supplierCompanyId={supplierCompanyId} supplierCompanyName={supplierCompanyName} setDetails={setDetails} detailComplete={actionComplete} />}
        </div>
    );
}

export default ListPartners;